import React from 'react';
import ComingSoonPanel from './ComingSoonPanel';
import StatsPanel from './StatsPanel';
import P2EPanel from './P2EPanel';
export let StatsTab;

(function (StatsTab) {
  StatsTab["Hero"] = "Hero";
  StatsTab["P2E"] = "P2E Info";
  StatsTab["Stats"] = "Stats";
  StatsTab["Fury"] = "Fury";
  StatsTab["Passive"] = "Passive";
})(StatsTab || (StatsTab = {}));

export function renderStatPanel({ ...props
}) {
  switch (props.tab) {
    case StatsTab.P2E:
      {
        return /*#__PURE__*/React.createElement(P2EPanel, {
          item: props.item,
          reward: props.reward
        });
      }

    case StatsTab.Stats:
      {
        return /*#__PURE__*/React.createElement(StatsPanel, {
          item: props.item,
          description: props.description
        });
      }

    default:
      {
        return /*#__PURE__*/React.createElement(ComingSoonPanel, null);
      }
  }
}